import api from '../../../lib/api';
import type {
  CreateSegmentInput,
  ExecuteSegmentInput,
  LeadResult,
  LinkedInSearchSegment,
  UpdateSegmentInput,
} from '../types';

export const linkedinSearchAPI = {
  createSegment: (data: CreateSegmentInput) =>
    api.post<LinkedInSearchSegment>('/linkedin-search/segments', data),

  listSegments: (organizationId: string) =>
    api.get<LinkedInSearchSegment[]>('/linkedin-search/segments', {
      params: { organizationId },
    }),

  getSegment: (id: string, organizationId: string) =>
    api.get<LinkedInSearchSegment>(`/linkedin-search/segments/${id}`, {
      params: { organizationId },
    }),

  updateSegment: (id: string, organizationId: string, data: UpdateSegmentInput) =>
    api.patch<LinkedInSearchSegment>(`/linkedin-search/segments/${id}`, data, {
      params: { organizationId },
    }),

  deleteSegment: (id: string, organizationId: string) =>
    api.delete(`/linkedin-search/segments/${id}`, {
      params: { organizationId },
    }),

  executeSegment: (id: string, organizationId: string, data?: ExecuteSegmentInput) =>
    api.post<{ message: string; segmentId: string }>(
      `/linkedin-search/segments/${id}/execute`,
      data || {},
      { params: { organizationId } },
    ),

  getSegmentResults: (id: string, organizationId: string, limit = 50, offset = 0) =>
    api.get<LeadResult[]>(`/linkedin-search/segments/${id}/results`, {
      params: { organizationId, limit, offset },
    }),
};
